export var isArray = Array.isArray;
export function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/common/arrays.js
// module id = 407
// module chunks = 4